// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    MAGAZINE_ARCHIVE_LOADING() {
      return {
        isLoading: true,
        magazineArchive: action.magazineArchive
      };
    },
    MAGAZINE_ARCHIVE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(adsConfig, site, 'magazineArchive');

      return {
        isLoading: false,
        data: action.magazineArchive,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchive.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
